<template>
  <div>
    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div class="row" v-if="!loading">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          >
            <thead>
              <tr>
                <th colspan="4">
                  <h5 class="h3 mb-3 text-gray-800 text-center">
                    {{ $t("Detalhes da Situação de Violação de Direitos") }}
                  </h5>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL:
                  <b v-if="item.responsavel">{{ item.responsavel.nome }}</b>
                </td>
                <td colspan="2">
                  UNIDADE DE ORIGEM:
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TÉCNICO AUTOR:
                  <b>{{ item.autor }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TÉCNICOS PARTICIPANTES:
                  <b v-for="(tecnico, index) in item.outros_tecnicos">
                    {{ tecnico.nome }}
                    <span v-if="index < item.outros_tecnicos.length - 1"
                      >,
                    </span>
                  </b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  VÍTIMA(S):<br />
                  <strong
                    class="mr-2"
                    v-for="(pessoa, index) in item.pessoas_objetos"
                    :key="pessoa.id"
                  >
                    {{ pessoa.nome_completo }}
                    <span v-if="index < item.pessoas_objetos.length - 1"
                      >,</span
                    >
                  </strong>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  SITUAÇÃO:<br />
                  <ol>
                    <li v-for="item in item.violacoes_nomes" :key="item.id">
                      <b>{{ item.descricao }}</b>
                    </li>
                  </ol>
                </td>
                <td>
                  STATUS:
                  <strong v-html="item.status_nome"></strong>
                </td>
              </tr>

              <tr>
                <td colspan="4">
                  ACOMPANHADO PELO CREAS:
                  <b
                    ><span v-if="item.acompanhamento_creas">SIM</span
                    ><span v-else>NÃO</span></b
                  >
                </td>
              </tr>
              <tr v-if="item.acompanhamento_creas">
                <td colspan="2">
                  UNIDADE CREAS:
                  <b
                    >{{ item.creas.nome }} - {{ item.creas.email }} -
                    {{ item.creas.telefone }}</b
                  >
                </td>
                <td>
                  DATA DO INICIO DO ACOMPANHADO:
                  <b>{{ item.acomp_data_inicial | formatDate() }}</b>
                </td>
                <td>
                  DATA DO FINAL DO ACOMPANHADO:
                  <b>{{ item.acomp_data_final | formatDate() }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  OBSERVAÇÃO:
                  <div v-html="item.descricao"></div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-center">
                  <br />
                  <b v-if="item.responsavel">{{ item.responsavel.nome }}</b
                  ><br />
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
                <td colspan="2" class="text-center">
                  <br />
                  <b>Assinatura da Vítima ou Pessoa Responsável</b>
                </td>
              </tr>
            </tbody>
          </table>

          <print-footer
            v-if="item.responsavel.assinatura_digital"
            :tecnico="item.responsavel"
            class="mt-0"
            :assinatura="item.responsavel.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />

          <span
            class="mr-2"
            v-for="(tecnico, index) in item.outros_tecnicos"
            :key="index"
            v-if="outrasAssinaturas"
          >
            <print-footer
              :tecnico="tecnico"
              class="mt-0"
              :assinatura="tecnico.assinatura_digital"
            />
          </span>

          <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <router-link
                :to="`/dashboard/violacaodedireitos/edit/${item.id}?familia_id=${item.familia_id.id}`"
                class="btn btn-default"
              >
                <i class="mdi mdi-arrow-left" />
              </router-link>

              <a class="btn btn-sm py-1 btn-primary" @click="print()">
                <i class="mdi mdi-printer mdi-18px" />
              </a>

              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="email"
                  label="Email"
              />
              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="wpp"
                  label="Telefone/WhatsApp"
              />
              <form-toggle
                grid="12"
                mt="0"
                v-model="outrasAssinaturas"
                label="Assinatura Técnico (a) Participante"
              />
            </div>
          </div>
        </print-content>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      outrasAssinaturas: false,
      wpp: true,
      email: true
    };
  },
  mounted() {
    this.getUnidades();
    this.getServicos();
    this.getItem();
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/violacaodedireitos/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;
      });
    },
    getUnidades() {
      axios
        .get(`api/dashboard/unidades/get/externas/PLANTAO`)
        .then((response) => {
          this.unidades = response.data;
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
  },
};
</script>
